import { createContext, useContext, useEffect, useState } from "react";
import "./login.css"
import axios from "axios";
import { Link, Route, Routes, useNavigate } from "react-router-dom";
import RestPassword from "./RestPassword";
import Sync from "./sync";
import { loginkey } from "./LoginContext";
import { useMediaQuery } from "react-responsive";
import React from "react";


function Register() {
    const [uploadmessage, setUploadMessage] = useState("");
    const [confirmMessage, setConfirmMessage] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [sentCode, setSentCode] = useState(false);
    const [code, setCode] = useState("");
    const [message, setMessage] = useState("");
    const [codeMessage, setCodeMessage] = useState("");
    const [renew, setRenew] = useState(false);
    const [infoo, setInfoo] = useState([]);
    const { setAuth } = useContext(loginkey);
    const [acceptTerms, setAcceptTerms] = useState(false)
    const domainUrl= "drclinic.hassan-mohammad.tech"
    const checkRegisteredEmail = async (e) => {
        setUploadMessage('')
        await fetch(`https://${domainUrl}/php/checkRegisteredEmail.php?email=${e}`,
            {
                headers: {
                    "Content-Type": "text/html",
                    "charset": "utf-8"
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    setMessage('Loading...')
                    throw Error('Could not fetch the data')
                }
                else if (response.ok) {
                    setMessage('Done')
                    return response.json()
                }
            })
            .then((data) => {
                if (data.values.length > 0) {
                    setUploadMessage('Already registered')
                }
                return (
                    setInfoo(data.values));
            })
            .catch(err => {
                setMessage(err.message)
            })
    };


    function sendEmail(event) {
        if (uploadmessage !== 'Already registered') {
            event.preventDefault();
            setUploadMessage('Loading...')
            const url = `https://${domainUrl}/php/sendemailRegister.php`;
            const formData = new FormData();
            formData.append('email', email);
            formData.append('message', message);
            const config = {
                headers: {
                    "Content-Type": "text/html",
                    "charset": "utf-8"
                },
            };
            axios.post(url, formData, config).then(response => {
                if (response.status === 200) {
                    setUploadMessage("Done")
                    setRenew(true);
                }
            })
                .catch(error => {
                    setMessage('Done')
                    setUploadMessage(error.message)
                    console.log(error);
                });
            setSentCode(true)
        } else {
            setUploadMessage('Already registered')
        }
    }

    const handleRegister = async (event) => {
        //event.preventDefault();
        setUploadMessage('Loading...')
        const url = `https://${domainUrl}/php/register.php`;
        const formData = new FormData();
        formData.append('email', email);
        formData.append('password', password);
        const config = {
            headers: {
                "Content-Type": "text/html",
                "charset": "utf-8"
            },
        };
        axios.post(url, formData, config).then(response => {
            if (response.status === 200) {
                setUploadMessage("Done")
                window.location.reload()
                navToGet();
            }
        })
            .catch(error => {
                setUploadMessage(error.message)
                console.log(error);
            });
    }


    const getRest = async (event) => {
        event.preventDefault();
        await fetch(`https://${domainUrl}/php/checkCodeRegister.php?code=${code}`,
            {
                headers: {
                    "Content-Type": "text/html",
                    "charset": "utf-8"
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    setMessage('Loading...')
                    throw Error('Could not fetch the data')
                }
                else if (response.ok) {
                    setMessage('Done')
                    return response.json()
                }
            })
            .then((data) => {
                if (data.values.length > 0) {
                    handleRegister();
                    setCodeMessage('Done')
                }
                else {
                    setCodeMessage("Wrong Code")
                }
                return (
                    setInfoo(data.values));
            })
            .catch(err => {
                setMessage(err.message)
            })
    };

    function handleTerms() {
        setAcceptTerms(!acceptTerms)
    }


    var sha1 = require('sha1');

    const handleCodeChange = (e) => {
        setCode(e.target.value);
    }
    /*const handlereNewChange = () => {
        sendEmail();
        setRenew(true);
    }*/

    const handleEmailChange = (e) => {
        checkRegisteredEmail(e.target.value)
        setEmail(e.target.value);
    }
    const handlePasswordChange = (e) => {
        setConfirmMessage("")
        setPassword(sha1(`${e.target.value}`));
        if (password !== sha1(e).toString()) {
            setConfirmMessage('Please enter the same password')
        }
    }
    const handleConfirmPasswordChange = (e) => {
        setConfirmMessage("")
        setConfirmPassword(sha1(e.target.value).toString());
        if (password !== sha1(e.target.value).toString()) {
            setConfirmMessage('Please enter the same password')
        }
    }
    const navigate = useNavigate()
    function navToDonations() {
        navigate("/Donations", { replace: true });
    }
    function navToGet() {
        navigate("/", { replace: true });
    }
    function navTerms() {
        navigate("/TermsAndPrivecy", { replace: true });
    }
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1224px)'
    })
    const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
    return (
        <div>
            {isDesktopOrLaptop && <div className="login-page">
                <div className="container">
                    {renew && <div className="rest-send">
                        <div className="container-send">
                            <div className="submit-container">
                                <div>Please enter the code</div>
                                <form className="form-submit">
                                    <input className="form-control" onChange={(event) => { handleCodeChange(event) }} required></input>
                                    <div className="submit-btn-container">
                                        <button className="btn btn-dark submit-btn" onClick={getRest}>Submit</button>
                                    </div>
                                    {codeMessage && <div className="label-text">{codeMessage}</div>}
                                </form>
                            </div>
                        </div>
                    </div>}
                    {!renew && <div className="container" >
                        <div className="login-container">
                            <form className="login-form" onSubmit={sendEmail}><h4 className="title-login">Create your account</h4>
                                <input type="email" className="form-control login-input" placeholder="Email" onChange={(event) => { handleEmailChange(event) }} required></input>
                                <input type="password" className="form-control login-input" placeholder="Password" onChange={(event) => { handlePasswordChange(event) }} required></input>
                                <input type="password" className="form-control login-input" placeholder="Confirm Password" onChange={(event) => { handleConfirmPasswordChange(event) }} required></input>
                                {confirmMessage && <div className="label-text">{confirmMessage}</div>}
                                <div className="login-btn-container">
                                    <button type="submit" className="btn btn-dark login-btn" disabled={password !== confirmPassword || uploadmessage === 'Already registered'}>Register</button>
                                </div>
                                {uploadmessage && <div className="label-text">{uploadmessage}</div>}
                            </form>
                        </div>
                    </div>}
                </div>
            </div>}
            {isTabletOrMobile && <div className="login-page-mobile">
                <div className="container-mobile">
                    {renew && <div className="rest-send-mobile">
                        <div className="container-send-mobile">
                            <div className="submit-container-mobile">
                                <div>Please enter the code</div>
                                <form className="form-submit-mobile">
                                    <input className="form-control input-form-mobile" onChange={(event) => { handleCodeChange(event) }} required></input>
                                    <div className="submit-btn-container-mobile">
                                        <button className="btn btn-dark submit-btn" onClick={getRest}>Submit</button>
                                    </div>
                                    {codeMessage && <div className="label-text">{codeMessage}</div>}
                                </form>
                            </div>
                        </div>
                    </div>}
                    {!renew && <div className="container-mobile">
                        <div className="login-container-mobile" >
                            <form className="login-form-mobile" onSubmit={sendEmail}><h4 className="title-login">Create your account</h4>
                                <input type="email" className="form-control login-input" placeholder="Email" onChange={(event) => { handleEmailChange(event) }} required></input>
                                <input type="password" className="form-control login-input" placeholder="Password" onChange={(event) => { handlePasswordChange(event) }} required></input>
                                <input type="password" className="form-control login-input" placeholder="Confirm Password" onChange={(event) => { handleConfirmPasswordChange(event) }} required></input>
                                {confirmMessage && <div className="label-text">{confirmMessage}</div>}
                                <div className="login-btn-container-mobile">
                                    <button className="btn btn-dark login-btn" disabled={password !== confirmPassword || uploadmessage === 'Already registered'}>Register</button>
                                </div>
                                {uploadmessage && <div className="label-text">{uploadmessage}</div>}
                            </form>

                        </div>
                    </div>}
                </div>
            </div>}
        </div>
    );
}

export default Register;



/*<div className="donation">
                            <h4>All our services are free. But if you would like to support us</h4>
                            <h4 style={{ color: '#ffa400' }} onClick={navToDonations}>Click here</h4>
                        </div>*/
/*<div>
                                    <input
                                        type="checkbox"
                                        onChange={handleTerms}
                                    ></input>
                                </div>*/
//<a className="forgot-link title-login" onClick={navTerms}>Our terms and privecy</a>